<template>
	<div
		class="steps__step"
		:class="( is_completed_step ) ? ' steps__step--completed' : ( is_current_step ) ? ' steps__step--active' : null"
	>
		<div class="steps__step-number">
			{{ step.step_number }}
		</div>
		<div class="steps__step-title-wrapper">
			<h2 class="steps__step-title">
				{{ step.title }}
			</h2>
			<template v-if="is_completed_step">
				<ul class="steps__step-summary">
					<li v-if="form_fields.pandadoc_id">
						PandaDoc ID: {{ form_fields.pandadoc_id }}
					</li>
				</ul>
			</template>
		</div>
		<button
			v-if="is_completed_step"
			class="button button--smaller"
			type="button"
			@click="setActiveStep( step.step_number )"
		>
			Edit
		</button>
		<template v-else-if="is_current_step">
			<PandaDocFormComponent
				:step-title="step.title"
				@complete-form="setActiveStep( step.step_number + 1 )"
			/>
		</template>
	</div>
</template>

<script setup>
import { useAddProjectScopeStore } from '../../stores/add-project-scope.js';
import { computed, defineProps } from 'vue';
import { storeToRefs } from 'pinia';
import PandaDocFormComponent from './PandaDocFormComponent';

const add_project_scope_store = useAddProjectScopeStore();

const { setActiveStep } = add_project_scope_store;
const { form_fields } = storeToRefs( add_project_scope_store );

const props = defineProps( {
	step: {
		required: true,
		type: Object
	},
	activeStepNumber: {
		required: true,
		type: Number
	}
} );

const is_current_step = computed( () => {
	return props.step.step_number === props.activeStepNumber;
} );

const is_completed_step = computed( () => {
	return props.step.step_number < props.activeStepNumber;
} );
</script>
